import AgreeToTermsField from 'routes/ReferralForm/AgreeToTermsField/AgreeToTermsField';

export default AgreeToTermsField;
